import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SecureStorageService } from './secure-storage.service';

export interface CreateStreamPaymentResponse {
  status: number;
  data?: { reference: string; transaction_id?: string };
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class LivePaymentService {
  private token: string = '';
  private httpOptions: { headers: HttpHeaders } = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': ''
    })
  };

  constructor(
    private http: HttpClient,
    private secureStorage: SecureStorageService
  ) {
    this.token = this.secureStorage.getItem<string>('token')?.replace(/"/g, '') || '';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.token}`
      })
    };
  }

  /** Crée un paiement pour un live payant. POST /live-payments */
  createStreamPayment(params: {
    stream_id: number;
    amount: number;
    currency: string;
    reference: string;
    transaction_id?: string;
    type_payment_id?: number;
    source?: string;
  }): Observable<CreateStreamPaymentResponse> {
    const body = {
      stream_id: params.stream_id,
      amount: params.amount,
      currency: params.currency,
      reference: params.reference,
      type_payment_id: params.type_payment_id ?? 2,
      source: params.source ?? 'web',
      ...(params.transaction_id && { transaction_id: params.transaction_id }),
    };
    return this.http.post<CreateStreamPaymentResponse>(`${environment.apiUrl}/live-payments`, body, this.httpOptions);
  }

  /** Vérifie le statut d'un paiement live. GET /live-payments/check-status/:reference */
  checkPaymentStatus(reference: string, phone?: string): Observable<{ status: string }> {
    const path = phone
      ? `${environment.apiUrl}/live-payments/check-status/${reference}/${phone}`
      : `${environment.apiUrl}/live-payments/check-status/${reference}`;
    return this.http.get<{ status: string }>(path, this.httpOptions);
  }
}
